import React, { useState } from "react";
import database from "../firebase";

const Contact = () => {
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const submitCustomer = (e) => {
    e.preventDefault();

    if (!name && !message) return alert("Please Enter the details...");

    database
      .collection("usets")
      .add({
        name: name,
        subject: subject,
        email: email,
        message: message,
      })
      .then(() => alert("Thank for registering.."));

    setName("");
    setSubject("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className="w-full pb-8 bg-gray-800 pt-5 p-5">
      <h1 className="text-center text-white font-medium text-xl">
        Get In Touch
      </h1>
      <div className="grid sm:place-items-center mt-3">
        <div className="grid sm:w-5/12">
          <div className=" bg-gray-700 rounded shadow-lg ">
            <form className="px-4 py-3 space-y-2">
              <div className="space-y-2">
                <label
                  htmlFor="Name"
                  className="text-sm font-medium text-white"
                >
                  name
                </label>
                <div>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    className="w-full focus:outline-none bg-gray-600 text-white rounded-sm p-1 py-2 "
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label htmlFor="Name" className="textsm font-medium text-white">
                  subject
                </label>
                <div>
                  <input
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    type="text"
                    className="w-full focus:outline-none bg-gray-600 text-white  rounded-sm p-1 py-2"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <label htmlFor="Name" className="textsm font-medium text-white">
                  email
                </label>
                <div>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="text"
                    className="w-full focus:outline-none bg-gray-600 text-white  rounded-sm p-1 py-2"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <label htmlFor="Name" className="textsm font-medium text-white">
                  message
                </label>
                <div>
                  <input
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    type="text"
                    className="w-full focus:outline-none bg-gray-600 text-white rounded-sm p-1 py-6"
                  />
                </div>
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  onClick={submitCustomer}
                  className=" bg-transparent border hover:bg-gray-50 border-gray-200 mb-5 mt-3 text-white font-medium hover:text-black  focus:outline-none py-2 w-full rounded-sm "
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
